<template>
  <div class="header">
    <div
      v-for="tab in tabs"
      :key="tab.id"
      class="header-item"
      :class="{ active: isActiveTab(tab) }"
      @click="onChangeTab(tab)"
    >
      {{ $t(tab.labelKey) }}
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

/** 商業募集（/event/theme, /event/company）のサブナビゲーション */
const tabs = [
  { id: "theme", path: "/event/theme", labelKey: "eventHeader.tabs.theme" },
  { id: "company", path: "/event/company", labelKey: "eventHeader.tabs.company" },
] as const;

type Tab = typeof tabs[number];

export default Vue.extend<Data, Methods, Computed, Props>({
  data() {
    return {
      tabs,
    };
  },
  computed: {
    isActiveTab() {
      return (tab) => this.$route.path === tab.path;
    },
  },
  methods: {
    onChangeTab(tab) {
      if (this.$route.path === tab.path) return;
      this.$router.push({ path: tab.path });
    },
  },
});

interface Props {}

interface Data {
  tabs: typeof tabs;
}

interface Computed {
  isActiveTab(tab: Tab): boolean;
}

interface Methods {
  onChangeTab(tab: Tab): void;
}
</script>

<style lang="scss" scoped>
.header {
  background-color: var(--color-surface-subtle);
  display: flex;
  box-sizing: border-box;
  padding: 20px;
  box-shadow: var(--shadow-sm);
  z-index: 1;

  .header-item {
    margin: 0 10px;
    font-weight: var(--font-weight-bold);
    font-size: 1.2em;
    cursor: pointer;
    color: var(--color-text-low);

    &.active {
      color: var(--color-primary);
    }
  }
}
</style>
